const INVESTOR_ROWS = [
  { investor: "ficosec" },
  { investor: "implementer" },
  { investor: "allied" }
]

const INVESTOR_TOTAL_LABELS = {
  ficosec: "Total presupuestado FICOSEC",
  implementer: "Total presupuestado Implementadora",
  allied: "Total presupuestado Aliados"
}

export const getInvestmentByInvestors = (ministrationPeriods = []) => {
  return INVESTOR_ROWS.map(({ investor }) => {
    const periodColumns = {}
    let totalInvestmentByInvestor = 0

    ministrationPeriods.forEach(({ ministrationBudget, orderIndex }) => {
      if ("ficosec".includes(investor)) {
        const ficosecInvestment = Number(ministrationBudget?.ficosec || 0)

        periodColumns[`period${orderIndex}-investment`] = ficosecInvestment
        totalInvestmentByInvestor += ficosecInvestment
      }

      if ("implementer".includes(investor)) {
        const implementerInvestment = Number(ministrationBudget?.implementer || 0)
        periodColumns[`period${orderIndex}-investment`] = implementerInvestment

        totalInvestmentByInvestor += implementerInvestment
      }

      if ("allied".includes(investor)) {
        const totalAlliedInvestment = Number(ministrationBudget?.alliedOne || 0)
          + Number(ministrationBudget?.alliedTwo || 0)

        periodColumns[`period${orderIndex}-investment`] = totalAlliedInvestment
        totalInvestmentByInvestor += totalAlliedInvestment
      }
    })
    return { investor: INVESTOR_TOTAL_LABELS[investor], ...periodColumns, totalInvestmentByInvestor }
  })
}